import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

import CloseIcon from "@material-ui/icons/Close";

import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import cartStyle from "assets/jss/material-dashboard-pro-react/views/cartStyle.js";

import getCoupon from "api/getCoupon";

/* *************** INIZIALIZZAZIONE DI CODICE PROMOZIONALE ********* */
/*
  codice: "",
  created_at: "",
  created_by: null,
  flag_abilitato: false,
  id: null,
  organisation: null,
  sconto: 0,
  updated_at: null,
  updated_by: null
*/

const useStyles = makeStyles(cartStyle);

function PromotionalCode(props) {
  const { t } = useTranslation();

  const {
    museum,
    customStyle,
    promotionalCode,
    updatePromotionalCode,
    updateAlert,
  } = props;
  const classes = useStyles();

  const [promotionalCodeState, setPromotionalCodeState] = useState("");

  // const logo = `${config.cdn}sites/lib/mcdonald/mc_donalds_150.png`;

  function resetPromotionalCode() {
    // CONTROLLARE SE NEL RISTORANTE NON ESISTE UNO SCONTO GENERICO
    updatePromotionalCode({
      codice: "",
      created_at: "",
      created_by: null,
      flag_abilitato: false,
      id: null,
      organisation: null,
      sconto: 0,
      updated_at: null,
      updated_by: null,
      codice_articolo: null,
      // RESET CATEGORY
      nome_categoria: null,
      id_categoria: null //
    });
  }

  async function sendPromotionalCode() {
    /* CERCO TUTTE LE CATEGORIE CHE HO MESSO A CARRELLO (2 METODI) */

    /* 1 METODO */
    // const allCategoryInCart = [];
    // cart.forEach(item => {
    //   if (allCategoryInCart.indexOf(item.categoria_articolo) === -1) {
    //     allCategoryInCart.push(item.categoria_articolo);
    //   }
    // });
    const couponChecked = await getCoupon(
      museum.organisation.id,
      promotionalCodeState
    );

    // TODO: se cambia la creazione del coupon aggiornare la condizione qui sotto per attivare il codice
    if (
      couponChecked &&
      couponChecked[0] &&
      couponChecked[0].categorie &&
      couponChecked[0].categorie.some(el => el.nome_categoria === "Biglietti")
    ) {
      // ESISTE UN CODICE SCONTO CON IL CODICE SCRITTO DALL\' UTENTE
      updatePromotionalCode(
        Object.assign({}, couponChecked[0], {
          codice_articolo: couponChecked[0].id,
          nome_categoria: couponChecked[0].categorie[0].nome_categoria
        })
      );
      updateAlert({
        success: true,
        danger: false,
        title: t("cart.promotional_title_success"),
        onConfirm: () => {
          updateAlert(null);
        },
        onCancel: () => {
          updateAlert(null);
        },
        showCancel: false,
        confirmBtnText: "OK",
        cancelBtnText: "",
        text: t("cart.promotional_description_success")
      });
    } else {
      let error = "GENERAL_ERROR";
      let text = t(`cart.promotional_${error}`);
      updateAlert({
        success: false,
        danger: true,
        title: t("cart.promotional_error_title"),
        onConfirm: () => {
          updateAlert(null);
        },
        onCancel: () => {
          updateAlert(null);
        },
        showCancel: false,
        confirmBtnText: "OK",
        cancelBtnText: "",
        text: text
      });
    }

    // if (promotionalCode && promotionalCode.id) {
    //   return resetPromotionalCode();
    // }
    //
    // const allCategoryInCart = cart.reduce((prev, current) => {
    //   if (prev.indexOf(current.categoria_articolo) === -1) {
    //     return [...prev, current.categoria_articolo];
    //   } else {
    //     return prev;
    //   }
    // }, []);
    //
    // /* OTTENGO TUTTI I CODICI SCONTO CHE POSSO USARE PER GLI ARTICOLI NEL CARRELLO*/
    // const allPromotionalCode = [];
    // articles.forEach(item => {
    //   if (allPromotionalCode.findIndex(el => item.id === el.id) === -1) {
    //     item.codici_sconto.forEach(promotional => {
    //       if (promotional && promotional.flag_abilitato) {
    //         // IL CODICE PUÒ ESSERE UTILIZZATO
    //         allPromotionalCode.push({
    //           id: item.id,
    //           nome_categoria: item.nome_categoria,
    //           codici_sconto: promotional
    //         });
    //       }
    //     });
    //   }
    // });
    //
    // /* CREO UN ARRAY CON TUTTI I CODICI SCONTO CHE POSSO UTILIZZARE PER GLI ARTICOLI SELEZIONATI */
    // const findPromotionalCodeAvailable = allPromotionalCode
    //   .filter(el => {
    //     if (allCategoryInCart.indexOf(el.id) !== -1) {
    //       return true;
    //     }
    //     return false;
    //   })
    //   .filter(Boolean);
    //
    // if (
    //   findPromotionalCodeAvailable &&
    //   findPromotionalCodeAvailable.length > 0
    // ) {
    //   /* ESISTONO DEI CODICI SCONTO CHE POSSO UTILIZZARE*/
    //   /* CONTROLLO SE IL CODICE SCRITTO DALL'UTENTE È UN CODICE VALIDO */
    //   const findPromotionalCode = findPromotionalCodeAvailable.find(
    //     item =>
    //       item.codici_sconto.codice &&
    //       item.codici_sconto.codice.toUpperCase() &&
    //       promotionalCodeState &&
    //       promotionalCodeState.toUpperCase() ===
    //         item.codici_sconto.codice.toUpperCase()
    //   );
    //   if (findPromotionalCode) {
    //     // ESISTE UN CODICE SCONTO CON IL CODICE SCRITTO DALL\' UTENTE
    //     updatePromotionalCode(
    //       Object.assign({}, findPromotionalCode.codici_sconto, {
    //         codice_articolo: findPromotionalCode.id,
    //         nome_categoria: findPromotionalCode.nome_categoria
    //       })
    //     );
    //     updateAlert({
    //       success: true,
    //       danger: false,
    //       title: t("cart.promotional_title_success"),
    //       onConfirm: () => {
    //         updateAlert(null);
    //       },
    //       onCancel: () => {
    //         updateAlert(null);
    //       },
    //       showCancel: false,
    //       confirmBtnText: "OK",
    //       cancelBtnText: "",
    //       text: t("cart.promotional_description_success")
    //     });
    //   }
    // } else {
    //   let error = "GENERAL_ERROR";
    //   let text = t(`cart.promotional_${error}`);
    //   updateAlert({
    //     success: false,
    //     danger: true,
    //     title: t("cart.promotional_error_title"),
    //     onConfirm: () => {
    //       updateAlert(null);
    //     },
    //     onCancel: () => {
    //       updateAlert(null);
    //     },
    //     showCancel: false,
    //     confirmBtnText: "OK",
    //     cancelBtnText: "",
    //     text: text
    //   });
    // }
  }

  return (
    <>
      {!promotionalCode ||
      !promotionalCode.id ||
      !promotionalCode.flag_abilitato ? (
        <div
          className={classes.containerMenu}
          style={{ backgroundColor: "rgba(240,240,240,0.6)" }}
        >
          <div
            style={{
              marginTop: "10px",
              width: "100%",
              display: "block",
              marginBottom: "20px",
              paddingBottom: "10px"
            }}
          >
            <CustomInput
              labelText={t("cart.promotional_code")}
              inputProps={{
                value: promotionalCodeState || "",
                autoComplete: "off",
                onChange: e => {
                  if (promotionalCode && promotionalCode.id) {
                    // SE IL CODICE ESISTE NON POSSO MODIFICARLO
                  } else {
                    setPromotionalCodeState(e.target.value);
                  }
                }
              }}
              formControlProps={{
                fullWidth: true
              }}
              // style={{ float: "left" }}
            />
            <Button
              round={false}
              size="sm"
              color="lightBlue"
              // color="info"
              onClick={sendPromotionalCode}
              className={classes.buttonBig}
              style={{
                backgroundColor: customStyle.buttonAction
                // float: "left"
              }}
            >
              {promotionalCode && promotionalCode.id
                ? t("cart.remove")
                : t("cart.apply")}
            </Button>
          </div>
        </div>
      ) : null}
      {promotionalCode &&
      promotionalCode.id &&
      promotionalCode.flag_abilitato ? (
        <div
          className={classes.containerMenu}
          style={{
            backgroundColor: "rgba(240,240,240,0.6)",
            marginBottom: "10px"
          }}
        >
          <CloseIcon
            onClick={resetPromotionalCode}
            style={{
              marginRight: 0,
              color: customStyle.buttonAction,
              float: "right",
              cursor: "pointer"
            }}
          />
          <div
            className={classes.dishName}
            style={{
              lineHeight: "30px",
              fontWeight: "normal"
            }}
          >
            {t("cart.discount")}:{" "}
            <span style={{ fontWeight: "bold" }}>
              {promotionalCode.codice} -{" "}
              {(promotionalCode.sconto || 0).toFixed(2)}
              {"%"}
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
}

PromotionalCode.propTypes = {
  cart: PropTypes.arrayOf(PropTypes.object).isRequired,
  museum: PropTypes.objectOf(PropTypes.any).isRequired,
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string
  }).isRequired,
  cartParams: PropTypes.shape({
    totalPrice: PropTypes.number,
    deliveryCost: PropTypes.number,
    servicesFees: PropTypes.number,
    total: PropTypes.number,
    cartCounter: PropTypes.number,
    totToShow: PropTypes.number
  }).isRequired,
  promotionalCode: PropTypes.shape({
    codice: PropTypes.string,
    created_at: PropTypes.string,
    created_by: PropTypes.string,
    flag_abilitato: PropTypes.bool,
    id: PropTypes.number,
    organisation: PropTypes.string,
    sconto: PropTypes.number,
    updated_at: PropTypes.string,
    updated_by: PropTypes.string
  }).isRequired,
  updatePromotionalCode: PropTypes.func.isRequired,
  customStyle: PropTypes.object,
  updateAlert: PropTypes.func.isRequired,
  articles: PropTypes.arrayOf(PropTypes.object).isRequired
};
PromotionalCode.defaultProps = {
  customStyle: {}
};

export default withRouter(PromotionalCode);
